import {
  getEnumValuesFromPipelineSchema,
  getMinMaxSchemaValue,
} from '@flows/configs/shared/schemaUtils'
import { BaseSchema_ContentsPremiumBasicNeodigitalDe as schema } from '@flows/insurance/schemas'
import { getClaimsOptions } from '@flows/insurance/utils/stepContentUtils'

export const UPGRADES_MAP = {
  naturalDisasterProductKey: {
    contents_premium_basic_neodigital_de: 'contents_premium_natural_disasters_neodigital_de',
    contents_comfort_basic_neodigital_de: 'contents_comfort_natural_disasters_neodigital_de',
  },
  bikeProductKey: {
    contents_premium_basic_neodigital_de: 'contents_premium_bike_theft_neodigital_de',
    contents_comfort_basic_neodigital_de: 'contents_comfort_bike_theft_neodigital_de',
  },
  glassProductKey: {
    contents_premium_basic_neodigital_de: 'contents_premium_glass_neodigital_de',
    contents_comfort_basic_neodigital_de: 'contents_comfort_glass_neodigital_de',
  },
} as const

const deductiblesOptionsFromSchema = getEnumValuesFromPipelineSchema(schema.shape.deductible_amount)
const claimsOptionsFromSchema = getEnumValuesFromPipelineSchema(
  schema.shape.number_of_previous_claims
)

export const CONTENTS_CONSTANTS = {
  deductibles: deductiblesOptionsFromSchema,
  claimsOptions: getClaimsOptions(claimsOptionsFromSchema.length),
  livingSpace: {
    min: getMinMaxSchemaValue(schema.shape.living_space_square_meters.innerType(), 'min'),
    max: getMinMaxSchemaValue(schema.shape.living_space_square_meters.innerType(), 'max'),
  },
}
